/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SubmitUserContactFieldsMutationVariables = Types.Exact<{
  data: Types.SubmitContactFieldsInput;
}>;


export type SubmitUserContactFieldsMutation = (
  { __typename?: 'Mutation' }
  & { submitUserContactFields: Types.Maybe<(
    { __typename?: 'SubmitUserContactFieldsResult' }
    & Pick<Types.SubmitUserContactFieldsResult, 'id' | 'successful'>
    & { errors: Types.Maybe<Array<(
      { __typename?: 'ValidationItem' }
      & Pick<Types.ValidationItem, 'messages' | 'faultType' | 'field' | 'context'>
    )>> }
  )> }
);


export const SubmitUserContactFieldsDocument = gql`
    mutation submitUserContactFields($data: SubmitContactFieldsInput!) {
  submitUserContactFields(data: $data) {
    id
    successful
    errors {
      messages
      faultType
      field
      context
    }
  }
}
    `;
export type SubmitUserContactFieldsMutationFn = Apollo.MutationFunction<SubmitUserContactFieldsMutation, SubmitUserContactFieldsMutationVariables>;

/**
 * __useSubmitUserContactFieldsMutation__
 *
 * To run a mutation, you first call `useSubmitUserContactFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitUserContactFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitUserContactFieldsMutation, { data, loading, error }] = useSubmitUserContactFieldsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitUserContactFieldsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitUserContactFieldsMutation, SubmitUserContactFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitUserContactFieldsMutation, SubmitUserContactFieldsMutationVariables>(SubmitUserContactFieldsDocument, options);
      }
export type SubmitUserContactFieldsMutationHookResult = ReturnType<typeof useSubmitUserContactFieldsMutation>;
export type SubmitUserContactFieldsMutationResult = Apollo.MutationResult<SubmitUserContactFieldsMutation>;
export type SubmitUserContactFieldsMutationOptions = Apollo.BaseMutationOptions<SubmitUserContactFieldsMutation, SubmitUserContactFieldsMutationVariables>;